// extracted by mini-css-extract-plugin
module.exports = {"imageupload":"ImgUpload_imageupload__3kAKt"};